"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiContextProvider = void 0;
const dayjs_1 = require("dayjs");
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
const react_1 = __importDefault(require("react"));
const use_handle_color_scheme_1 = require("../color-scheme/use-handle-color-scheme");
const context_1 = require("./context");
(0, dayjs_1.extend)(localizedFormat_1.default);
(0, dayjs_1.extend)(customParseFormat_1.default);
const UiContextProvider = (props) => {
    (0, use_handle_color_scheme_1.useHandleColorScheme)(props.value.colorScheme);
    return react_1.default.createElement(context_1.UiContext.Provider, { value: props.value }, props.children);
};
exports.UiContextProvider = UiContextProvider;
exports.UiContextProvider.displayName = "UxfUiContextProvider";
